import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, InputNumber, notification} from 'antd';

import {getStaffRoleDiscountRateLimit, updateStaffRoleDiscountRateLimit} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {bindActionCreators} from "redux";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateStaffRoleDiscountRateLimitForm extends Component {

  static propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    /* state */
    loading: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
    staffRoleDiscountRateLimit: PropTypes.object.isRequired,
    /* actions */
    getStaffRoleDiscountRateLimit: PropTypes.func.isRequired,
    updateStaffRoleDiscountRateLimit: PropTypes.func.isRequired
  };

  componentDidMount() {
    this._loadStaffRoleDiscountRateLimit();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.staffRoleId !== this.props.match.params.staffRoleId) {
      this._loadStaffRoleDiscountRateLimit();
    }
  }

  _loadStaffRoleDiscountRateLimit = () => {
    const {staffRoleId} = decodeParams(this.props.match.params);
    this.props.getStaffRoleDiscountRateLimit({staffRoleId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {staffRoleId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      const discountRateLimit = values.discountRateLimitPercent / 100;
      try {
        await this.props.updateStaffRoleDiscountRateLimit({...values, staffRoleId, discountRateLimit});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {staffRoleDiscountRateLimit, form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    return (
      <Card title="Update Discount Limit">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Staff Role"
          >
            {staffRoleDiscountRateLimit.staffRoleName}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Discount Limit (%)"
          >
            {getFieldDecorator('discountRateLimitPercent', {
              initialValue: staffRoleDiscountRateLimit.discountRateLimit * 100,
              rules: [{
                required: true,
                message: 'Limit is required'
              }, {
                type: 'number',
                min: 0,
                max: 100,
                message: 'Limit must be in range 0 - 100'
              }]
            })(
              <InputNumber precision={0}/>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Discount Limit
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const UpdateStaffRoleDiscountRateLimitPage = Form.create()(UpdateStaffRoleDiscountRateLimitForm);

const mapStateToProps = state => ({
  loading: state.staffRoleDiscountRateLimit.staffRoleDiscountRateLimitLoading || state.staffRoleDiscountRateLimit.updatingStaffRoleDiscountRateLimit || false,
  staffRoleDiscountRateLimit: state.staffRoleDiscountRateLimit.staffRoleDiscountRateLimit || {discountRateLimit: 0},
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  getStaffRoleDiscountRateLimit,
  updateStaffRoleDiscountRateLimit,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(UpdateStaffRoleDiscountRateLimitPage);



// WEBPACK FOOTER //
// ./src/StaffRoleDiscountRateLimit/UpdateStaffRoleDiscountRateLimitPage.js